import * as THREE from 'three';
import { Group, ShaderMaterial } from 'three';
// import { Sky } from 'three/examples/jsm/objects/Sky.js';
import { Sky } from './Sky';
import { Water } from '../water/Water';
import { Reflector } from '../reflector/Reflector';
import { mergeBufferGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils';
// import { Water } from 'three/examples/jsm/objects/Water.js';
// import { OrbitControls } from '../controls/OrbitControls';
import store from '../store';
class Weather extends Group {
    props;
    waterTexture;
    snowTexture;
    renderer;
    scene;
    camera;
    _sunColor = 0xffffff;
    // _waterColor: string | number = 0x001e0f;
    _waterColor = 0x274461;
    // _waterColor: string | number = 0x29b0ff;
    _water;
    water1;
    sunDirection;
    skyColorOpacity = 0.4;
    lightColor = new THREE.Color(0xffffff);
    exposure;
    angle;
    _sky;
    waves;
    reflectMesh;
    rain;
    cloud;
    sunnyCloud;
    active = 'sunny';
    skySize = 10000;
    snow = new THREE.Group();
    isSunset = false;
    light;
    ambientLight;
    environments = [];
    rainAnimateFn = [];
    cloudAnimateFn = [];
    snowAnimateFn = [];
    wavesAnimateFn = [];
    reflectAnimateFn = [];
    get sky() {
        return this._sky;
    }
    get water() {
        return this._water;
    }
    animateId = -1;
    animate; // 动画
    constructor(data) {
        super();
        store.weather = this;
        // 先清除之前的绑定事件
        store.off('set-sunset');
        store.on('set-sunset', this.setSunset.bind(this));
        const { renderer, scene, camera } = data;
        this.renderer = renderer;
        this.scene = scene;
        this.camera = camera;
        this.renderer.shadowMap.enabled = true;
        renderer.toneMapping = THREE.ACESFilmicToneMapping;
        this.props = data;
        this.waterTexture = require('@blade-sxp/map/src/assets/waternormals.jpg');
        this.snowTexture = [
            require('@blade-sxp/map/src/assets/snow.png'),
            require('@blade-sxp/map/src/assets/snow1.png'),
            require('@blade-sxp/map/src/assets/snow2.png'),
            require('@blade-sxp/map/src/assets/snow3.png'),
            require('@blade-sxp/map/src/assets/snow4.png'),
        ];
        this.addWater();
        // 初始设置晴天
        this.addSky();
        // this.position.set(0, 200, 2000);
        // const pmremGenerator = new THREE.PMREMGenerator(this.renderer);
        // this.environment = pmremGenerator.fromScene(sky).texture;
        // const clock = new THREE.Clock();
        // function ani() {
        //   requestAnimationFrame(ani);
        //   console.log(clock.getElapsedTime());
        // }
        // requestAnimationFrame(ani);
        // const div = document.getElementById('waterColor');
        store.emit('init-weather');
        this.animate = () => {
            this.animateId = window.requestAnimationFrame(this.animate);
            const rainFn = this.rainAnimateFn.shift();
            const cloudFn = this.cloudAnimateFn.shift();
            const snowFn = this.snowAnimateFn.shift();
            const wavesFn = this.wavesAnimateFn.shift();
            // const reflectFn = this.reflectAnimateFn.shift();
            rainFn && rainFn();
            snowFn && snowFn();
            cloudFn && cloudFn();
            wavesFn && wavesFn();
            this.water && (this.water.material.uniforms['time'].value += 1.0 / 60.0);
            this.water1 && (this.water1.material.uniforms['time'].value += 1.0 / 60.0);
            // this.setShadowMap();
            // if (process.env.NODE_ENV === 'development') {
            //   div && (this.water.material.uniforms['waterColor'].value = new THREE.Color(div.style.background || 0x0000ff));
            // }
        };
        this.animate();
    }
    /** 设置日落 */
    setSunset() {
        if (!this.sky)
            return;
        this.isSunset = true;
        const sun = new THREE.Vector3();
        const angle = 170;
        const skyUniforms = this.sky.material.uniforms;
        this.skyColorOpacity = 0.5;
        skyUniforms['turbidity'].value = 1; // 浑浊度,代表云层等对光纤的影响。
        skyUniforms['rayleigh'].value = 4; // 瑞利散射，由于大气密度随高度急剧降低，大气分子的散射效应相应减弱，天空的颜色也随高度由蔚蓝色变为青色（视觉效果就是傍晚晚霞的红光的深度）
        skyUniforms['mieCoefficient'].value = 0.005; // 光线发散程度
        skyUniforms['mieDirectionalG'].value = 0.97; // 光线聚集度
        // 不加入自己颜色
        skyUniforms['ratio'].value = 0.2; // 相对于自身的颜色占比
        skyUniforms['opacity'].value = this.skyColorOpacity; // 自己添加的颜色与天空比较占比
        skyUniforms['i_color'].value = new THREE.Color(0x810013); // 添加天空混入色
        skyUniforms['isSunset'].value = true; // 是否是夕阳模式
        sun.setFromSphericalCoords(1, THREE.MathUtils.degToRad(90 - angle), 0);
        // skyUniforms['sunPosition'].value.copy(sun);
        this.water && this.water.material.uniforms['sunDirection'].value.copy(sun).normalize();
        const sunsetPosition = sun.clone();
        sunsetPosition.y = 0.006;
        // 夕阳模式的光晕是和角度太阳有关，太阳位置由sunsetPosition进行更改，所以修改sun位置只产生光晕效果不改变太阳位置
        skyUniforms['sunsetPosition'].value = sun; // 夕阳角度
        skyUniforms['sunPosition'].value.copy(sunsetPosition);
        this.addLight(sun, angle, true);
        this.lightColor = new THREE.Color(0xf07f43);
        this.light.color.set(this.lightColor);
        this.ambientLight.intensity = 0.3;
        this.light.intensity = 2;
    }
    addWater() {
        // const waterGeometry = new THREE.PlaneGeometry(this.skySize / 2, this.skySize / 2);
        const mesh = this.scene.getObjectByName('water-mesh');
        if (!mesh)
            return;
        const waterGeometry = mesh.geometry;
        // const waterGeometry = new THREE.PlaneGeometry(500, 200);
        // scene.fog = new THREE.Fog('rgba(255,255,255,0.6)', 0.15, 1000);
        const water = new Water(waterGeometry, {
            textureWidth: 512,
            textureHeight: 512,
            waterNormals: new THREE.TextureLoader().load(this.waterTexture, (texture) => {
                texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
            }),
            sunDirection: new THREE.Vector3(),
            sunColor: 0xffffff,
            waterColor: this._waterColor,
            // waterColor: '#2d3851',
            distortionScale: 3.7,
            fog: this.scene.fog !== undefined,
            // 设置初始时是否显示倒影
            // reflect: true,
        });
        // 改变是否显示倒影
        // water.changeReflect(true);
        // water.position.set(160, -1, 3000);
        // water.rotation.x = -Math.PI / 2;
        // water.position.y = -1;
        // water.position.z = 270;
        // water.position.x = 230;
        water.name = 'water';
        water.position.y += 0.1;
        this._water = water;
        // this.water1 = water.clone();
        // this.water1.geometry = new THREE.CircleGeometry(20, 32);
        // this.water1.position.x = -79;
        // this.water1.position.y = -0.15;
        // this.water1.position.z = -18;
        // 曝光度， 阴天、雪天等适当降低
        // this.renderer.toneMappingExposure = 1;
        this.add(water);
        // this.add(this.water1);
    }
    addSky() {
        const sky = new Sky();
        sky.scale.setScalar(this.skySize);
        this._sky = sky;
        sky.name = 'sky';
        this.add(sky);
        this.updateSky();
    }
    angleToRad(angle) {
        return (angle * Math.PI) / 180;
    }
    updateSky(angle = 35, uniforms = {}, wrapAngle = 0) {
        if (this.isSunset)
            return;
        const sun = new THREE.Vector3();
        const skyUniforms = this.sky.material.uniforms;
        let moon = false;
        skyUniforms['turbidity'].value = uniforms.turbidity || 10; // 浑浊度,代表云层等对光纤的影响。
        skyUniforms['rayleigh'].value = uniforms.rayleigh || 0.5; // 瑞利散射，由于大气密度随高度急剧降低，大气分子的散射效应相应减弱，天空的颜色也随高度由蔚蓝色变为青色（视觉效果就是傍晚晚霞的红光的深度）
        skyUniforms['mieCoefficient'].value = uniforms.mieCoefficient || 0.005; // 光线发散程度
        skyUniforms['mieDirectionalG'].value = uniforms.mieDirectionalG || 0.2; // 光线聚集度
        skyUniforms['ratio'].value = 1 - (2 * Math.abs(Math.PI / 2 - THREE.MathUtils.clamp(this.angleToRad(angle), 0, Math.PI))) / Math.PI; // 相对于自身的颜色占比
        skyUniforms['opacity'].value = this.skyColorOpacity; // 自己添加的颜色与天空比较占比
        skyUniforms['i_color'].value = new THREE.Color(0x0000ff); // 添加天空混入色
        this.light && (this.light.intensity = 2);
        this.renderer.toneMappingExposure = this.exposure || 1;
        // -5°时出现过渡效果
        if ((angle > 180 && angle <= 182.5) || (angle < 0 && angle >= -2.5)) {
            let ang = 0;
            if (angle > 180)
                ang = angle - 180;
            if (angle < 0)
                ang = Math.abs(angle);
            moon = true;
            ang *= 2;
            const exposure = this.renderer.toneMappingExposure;
            skyUniforms['turbidity'].value = Math.max(0.2, 10 - 2 * ang);
            skyUniforms['rayleigh'].value = Math.max(0.01, 2 - 0.4 * ang);
            skyUniforms['mieCoefficient'].value = Math.max(0, 0.05 - 0.01 * ang);
            skyUniforms['mieDirectionalG'].value = Math.max(0, 0.8 - 0.16 * ang);
            this.renderer.toneMappingExposure = Math.max(0.5, exposure - ((exposure - 0.3) / 5) * ang);
            this.light && (this.light.intensity = Math.max(0.8, 1 - 0.1 * ang));
        }
        this.angle = angle;
        // // 调整喷泉的颜色和大小
        store.emit('pq-set-material', (material) => {
            material.color = new THREE.Color(0xaaaaff);
            material.opacity = 1;
        });
        if (angle > 182.5 || angle < -2.5) {
            // 夜光固定10度，从夜间2.5°开始出现  防止太亮
            moon = true;
            angle = 10;
            skyUniforms['turbidity'].value = 0.2;
            skyUniforms['rayleigh'].value = 0.01;
            skyUniforms['mieCoefficient'].value = 0;
            skyUniforms['mieDirectionalG'].value = 0;
            this.renderer.toneMappingExposure = 0.5;
            this.light && (this.light.intensity = 0.8);
            store.emit('pq-set-material', (material) => {
                material.color = new THREE.Color(0x3590e5);
                material.opacity = 0.6;
            });
        }
        const phi = THREE.MathUtils.degToRad(90 - angle);
        const theta = THREE.MathUtils.degToRad(wrapAngle);
        this.exposure = this.renderer.toneMappingExposure;
        sun.setFromSphericalCoords(1, phi, theta);
        this.sunDirection = sun.clone().normalize();
        this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
        // skyUniforms['sunPosition'].value.copy(sun);
        this.sky.material.uniforms['sunPosition'].value.copy(sun);
        this.water && this.water.material.uniforms['sunDirection'].value.copy(sun).normalize();
        // 夜间直接采用20°的灯光
        this.addLight(sun, angle, moon);
    }
    // setShadowMap() {
    //   if (!this.light || !store.camera) return;
    //   const cameraDistanse = store.camera.position.distanceTo(store.controls!.target);
    //   const distanse = 1000;
    //   const lightPosition = new THREE.Vector3();
    //   // 沿着相机看的位置朝着太阳的方向位置位移相机到看的位置的距离
    //   lightPosition.addVectors(store.controls!.target, this.sunDirection.clone().multiplyScalar(distanse));
    //   this.light.position.copy(lightPosition);
    //   this.light.lookAt(store.controls!.target);
    //   this.light.shadow.camera.far = 2000;
    //   this.light.shadow.camera.left = -1000; // box.min.x
    //   this.light.shadow.camera.right = 1000; // box.max.x
    //   this.light.shadow.camera.top = 1000; // box.max.z * 2
    //   this.light.shadow.camera.bottom = -1000;
    //   this.light.shadow.camera.updateMatrixWorld();
    //   this.light.shadow.needsUpdate = true;
    // }
    getLampCancas() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 100;
        canvas.height = 100;
        const radial = ctx.createRadialGradient(50, 50, 0, 50, 50, 50);
        radial.addColorStop(0.0, 'rgba(255, 255, 255, 0.8)');
        radial.addColorStop(1.0, 'rgba(255, 255, 255, 0)');
        ctx.arc(50, 50, 50, 0, Math.PI * 2);
        ctx.fillStyle = radial;
        ctx.fill();
        return canvas;
    }
    controlLights(open = false) {
        // 路灯
        const lamp = this.scene.getObjectByName('lamp');
        // 射灯光束
        const spotLight = this.scene.getObjectByName('sd-mesh');
        // 夜间灯效
        const reflectMesh = this.scene.getObjectByName('reflect-mesh');
        // 地面灯效
        const glow = this.scene.getObjectByName('glow-mesh');
        // 增加暖光
        if (!this.ambientLight) {
            // this.ambientLight = new THREE.AmbientLight(0xffa500, 0.03);
            this.ambientLight = new THREE.AmbientLight();
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        this.scene.add(this.ambientLight);
        if (open) {
            // this.scene.add(this.ambientLight);
            this.ambientLight.intensity = 0.2;
            spotLight && (spotLight.visible = true);
            glow && (glow.visible = true);
            lamp && (lamp.visible = true);
            reflectMesh && (reflectMesh.visible = true);
        }
        else {
            // this.scene.remove(this.ambientLight);
            this.ambientLight.intensity = 0.5;
            spotLight && (spotLight.visible = false);
            glow && (glow.visible = false);
            lamp && (lamp.visible = false);
            reflectMesh && (reflectMesh.visible = false);
        }
        // if (!lamp) return;
        // const mat = lamp.material as THREE.MeshStandardMaterial | THREE.MeshStandardMaterial[];
        // const canvas = this.getLampCancas();
        // const texture = new THREE.CanvasTexture(canvas!);
        // if (Array.isArray(mat)) {
        //   mat.forEach((e) => {
        //     e.emissiveMap = texture;
        //   });
        // } else {
        //   mat.emissiveMap = texture;
        // }
    }
    async addLight(sun, angle, moon = false) {
        const boxSize = 200;
        if (!this.light) {
            const directionalLight = new THREE.DirectionalLight(0xffffff, 2); // 光的颜色，光照强度
            directionalLight.castShadow = true;
            directionalLight.position.set(sun.x * boxSize, sun.y * boxSize, sun.z * boxSize);
            directionalLight.lookAt(this.scene.position);
            // const helper = new THREE.DirectionalLightHelper(directionalLight, 50);
            // this.scene.add(helper);
            // 设置阴影参数
            directionalLight.shadow.mapSize.width = 2 ** 12.5;
            directionalLight.shadow.mapSize.height = 2 ** 12.5;
            directionalLight.shadow.bias = (-0.0005 * window.screen.width) / 1920; // 调节条纹
            directionalLight.shadow.camera.near = -100;
            directionalLight.shadow.camera.far = 1000;
            directionalLight.shadow.camera.left = -1000; // box.min.x
            directionalLight.shadow.camera.right = 1500; // box.max.x
            directionalLight.shadow.camera.top = 500; // box.max.z * 2
            directionalLight.shadow.camera.bottom = -500; // box.min.z * 2
            this.light = directionalLight;
            this.light.name = 'skyLight';
            this.add(directionalLight);
            store.light = directionalLight;
        }
        else {
            this.light.position.set(sun.x * boxSize, sun.y * boxSize, sun.z * boxSize);
        }
        if (moon) {
            angle = 0;
            this.light.intensity = 0.5;
            this.controlLights(true);
        }
        else {
            this.light.intensity = 2;
            this.controlLights(false);
        }
        // 设置场景背景色
        const rgb = this.getRgb(20 + Math.abs(70 * Math.sin((angle * Math.PI) / 180)));
        this.setScenceBackground(rgb);
    }
    addCloud = (url, count, speed = 2, fromSunny = false) => {
        const texture = new THREE.TextureLoader().load(url);
        const mat = new THREE.MeshBasicMaterial({
            transparent: true,
            map: texture,
            depthWrite: false,
            side: THREE.DoubleSide,
            opacity: 0.9,
            color: 0xffffff,
        });
        const geometries = [];
        const meshTem = new THREE.Mesh();
        meshTem.renderOrder = -1;
        // 多层云叠加
        const randomArr = [1, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 4, 4, 5]; // 概率
        for (let i = 0; i < count; i++) {
            let r = 2000 + 500 * Math.random();
            const deg1 = Math.PI * 2 * Math.random(); // r的投影在xz平面与x轴的角度
            const num = randomArr[Math.floor(Math.random() * randomArr.length)];
            const deg2 = (Math.PI * Math.random() * num) / 10; // r与y轴的角度，为正值
            meshTem.position.y = r * Math.sin(deg2) + 250;
            r = r / Math.max(0.5, Math.sin(deg2));
            r = Math.max(r, 3500);
            const geom = new THREE.PlaneBufferGeometry((250 * Math.random() + 250) / Math.max(0.5, Math.cos(deg2)), (250 * Math.random() + 250) / Math.max(0.5, Math.cos(deg2)));
            meshTem.position.x = r * Math.cos(deg2) * Math.cos(deg1);
            meshTem.position.z = r * Math.cos(deg2) * Math.sin(deg1);
            meshTem.scale.set(1 + Math.random(), 1 + Math.random(), 1 + Math.random());
            meshTem.lookAt(new THREE.Vector3(0, 0, 0));
            meshTem.updateWorldMatrix(false, true);
            const geometry = geom.clone().applyMatrix4(meshTem.matrixWorld);
            geometries.push(geometry);
        }
        const mergedGeometry = mergeBufferGeometries(geometries);
        const mergedMesh = new THREE.Mesh(mergedGeometry, mat);
        if (fromSunny) {
            this.sunnyCloud = mergedMesh;
            this.sunnyCloud.name = 'sunnyCloud';
        }
        else {
            this.cloud = mergedMesh;
            this.cloud.name = 'cloud';
        }
        this.add(mergedMesh);
        const fn = () => {
            this.cloudAnimateFn.push(fn);
            const cloud = fromSunny ? this.getObjectByName('sunnyCloud') : this.getObjectByName('cloud');
            if (!cloud)
                return;
            // cloud.children.forEach((mesh) => {
            //   const item = mesh as THREE.Mesh;
            //   const { x, y, z } = item.position;
            //   const r = Math.sqrt(x ** 2 + z ** 2);
            //   const angle = Math.atan2(z, x);
            //   // 每次执行函数移动的角度
            //   const moveAngle = ((speed / 100) * Math.PI) / 180;
            //   item.position.set(r * Math.cos(angle + moveAngle), y, r * Math.sin(angle + moveAngle));
            //   // 根据入射光颜色改变云团颜色
            //   const mat = item.material as THREE.MeshBasicMaterial;
            if (this.angle < 0 || this.angle > 180) {
                mat.opacity = 0.1;
            }
            else if (this.angle > 170 || this.angle < 10) {
                mat.opacity = 0.9 - ((Math.abs(this.angle - 90) - 80) / 10) * 0.8;
            }
            else {
                mat.opacity = 0.9;
            }
            mat.needsUpdate = true;
            //   item.lookAt(this.camera.position);
            // });
            mergedMesh.rotation.y += speed / 10000;
        };
        fn();
        this.addCloud.move = fn;
    };
    addRain({ count = 3500, height = 1200, speed = 20, distance = 800, rainSize = 0.2, rainHeight = 20 }) {
        const { x, z } = this.camera.position;
        const material = new THREE.MeshBasicMaterial({
            color: 0xffffff,
            transparent: true,
            opacity: 0.3,
        });
        // mesh.rotation.set(0, 0, Math.PI)
        // const meshs: THREE.Mesh[] = [];
        const positions = [];
        const geometry = new THREE.ConeGeometry(rainSize, rainHeight, 16);
        // const group = new THREE.Group();
        const mesh = new THREE.InstancedMesh(geometry, material, count);
        geometry.computeVertexNormals();
        mesh.name = 'rain';
        // const matrix = new THREE.Matrix4();
        const meshTem = new THREE.Mesh(geometry, material);
        for (let i = 0; i < count; i++) {
            const position = {
                x: distance * Math.random() - distance / 2,
                y: height * Math.random(),
                z: distance * Math.random() - distance / 2,
            };
            const { x, y, z } = position;
            meshTem.position.set(x, y, z);
            meshTem.updateMatrix();
            const scaleRadius = Math.random() + 0.5;
            meshTem.scale.set(scaleRadius, Math.random() + 0.5, scaleRadius);
            mesh.setMatrixAt(i, meshTem.matrix);
            positions.push(position);
            // const m = new THREE.Mesh(geometry, material);
            // meshs.push(m);
            // m.position.set(position.x + x, position.y, position.z + z);
            // group.add(m);
        }
        this.rain = mesh;
        this.add(mesh);
        const fn = () => {
            this.rainAnimateFn.push(fn);
            this.getObjectByName('rain') &&
                positions.forEach((e, i) => {
                    let { x, y, z } = e;
                    y -= speed;
                    x = x + this.camera.position.x;
                    z = z + this.camera.position.z;
                    if (y < 0)
                        y = height;
                    e.y = y;
                    meshTem.position.set(x, y, z);
                    meshTem.updateMatrix();
                    mesh.setMatrixAt(i, meshTem.matrix);
                });
            mesh.instanceMatrix.needsUpdate = true;
        };
        fn();
    }
    addSnow = (url, count, speed = 1, distance = 1000, height = 1200) => {
        const textures = [];
        const meshs = [];
        const group = new THREE.Group();
        if (Array.isArray(url)) {
            url.forEach((e) => {
                const texture = new THREE.TextureLoader().load(e);
                textures.push(texture);
            });
        }
        const { x, y, z } = this.props.camera.position;
        textures.forEach((texture) => {
            const geom = new THREE.BufferGeometry();
            const material = new THREE.PointsMaterial({
                size: 3 * Math.random() + 1,
                transparent: true,
                opacity: 0.7,
                depthWrite: false,
                side: THREE.DoubleSide,
                map: texture,
                blending: THREE.AdditiveBlending,
                sizeAttenuation: true, // 是否相同尺寸
                // color: 0xffffff
            });
            material.needsUpdate = true;
            const position = new Float32Array(count * 3);
            const randomPositions = [];
            for (let i = 0; i < count; i++) {
                const randomX = distance * Math.random() - distance / 2;
                const randomY = height * Math.random();
                const randomZ = distance * Math.random() - distance / 2;
                randomPositions.push({
                    randomX,
                    randomY,
                    randomZ,
                });
                position[i * 3] = randomX + x;
                position[i * 3 + 1] = randomY;
                // Z轴还得加上海面距离
                position[i * 3 + 2] = randomZ + z;
            }
            geom.setAttribute('position', new THREE.BufferAttribute(position, 3));
            const particles = new THREE.Points(geom, material);
            particles.randomPositions = randomPositions;
            meshs.push(particles);
            group.add(particles);
        });
        group.name = 'snow';
        this.snow = group;
        this.add(group);
        let xx = x;
        let zz = z;
        const prePositions = [];
        const fn = () => {
            this.snowAnimateFn.push(fn);
            const { x, z } = this.camera.position;
            if (Math.abs(xx - x) > distance / 4 || Math.abs(zz - z) > distance / 4) {
                xx = x;
                zz = z;
                // 新生成一个POINTS替换之前的points，不然会出现相机看不见粒子的bug
                const points = [...group.children];
                points.forEach((e) => {
                    group.remove(e);
                    const arr = e.geometry.attributes.position.array;
                    const position = new Float32Array(count * 3);
                    for (let i = 0; i < arr.length; i++) {
                        position[i] = arr[i];
                    }
                    for (let i = 0; i < count; i++) {
                        position[i * 3] = e.randomPositions[i].randomX + xx;
                        position[i * 3 + 2] = e.randomPositions[i].randomX + zz;
                    }
                    const geom = new THREE.BufferGeometry();
                    geom.setAttribute('position', new THREE.BufferAttribute(position, 3));
                    const particles = new THREE.Points(geom, e.material);
                    particles.randomPositions = e.randomPositions;
                    group.add(particles);
                    e.geometry.dispose();
                });
            }
            this.getObjectByName('snow') &&
                group.children.forEach((item, index) => {
                    const e = item;
                    prePositions[index] = [];
                    const position = e.geometry.attributes.position;
                    const randomPositions = e.randomPositions;
                    for (let i = 0; i < count; i++) {
                        position.array[i * 3 + 1] -= speed;
                        position.array[i * 3] = randomPositions[i].randomX + xx;
                        position.array[i * 3 + 2] = randomPositions[i].randomZ + zz;
                        if (position.array[i * 3 + 1] < 0)
                            position.array[i * 3 + 1] = height + position.array[i * 3 + 1];
                        prePositions[index][i * 3] = position.array[i * 3];
                        prePositions[index][i * 3 + 1] = position.array[i * 3 + 1];
                        prePositions[index][i * 3 + 2] = position.array[i * 3 + 2];
                    }
                    position.needsUpdate = true;
                });
        };
        fn();
    };
    addWaves() {
        // const meshs = this.scene.getObjectByName('mergedMesh')?.clone() as THREE.Mesh;
        // if (!meshs) return;
        const meshs = [];
        const waters = [];
        this.scene.traverse((item) => {
            const e = item;
            // 地形和水面
            if (/dx-mesh/.test(e.name.toLowerCase())) {
                meshs.push(e);
            }
            if (e.name === 'water') {
                waters.push(e);
            }
        });
        // const water = this.getObjectByName('water');
        const uniforms = {
            iTime: { value: 0 },
            iResolution: { value: new THREE.Vector3(1, 1, 1) },
            iChannel0: {
                value: null,
            },
            normalY: { value: 0.2 },
            resolution: { value: 30 },
            MAX_RADIUS: { value: 2.2 }, // 值越小，越亮，波纹越高越明显
        };
        const waterUniforms = {
            iTime: { value: 0 },
            iResolution: { value: new THREE.Vector3(1, 1, 1) },
            iChannel0: {
                value: null,
            },
            normalY: { value: -1.0 },
            resolution: { value: 2000 },
            MAX_RADIUS: { value: 2 },
        };
        const material = new RainWaves({
            uniforms,
            side: THREE.DoubleSide,
            transparent: true,
            opacity: 0.5,
            // depthTest: false,
            // depthWrite: false,
        });
        const group = new THREE.Group();
        waters.forEach((water) => {
            const waterWaves = water?.clone();
            if (waterWaves) {
                waterWaves.material = material.clone();
                waterWaves.material.uniforms = waterUniforms;
                waterWaves.position.y += 0.01;
                group.add(waterWaves);
            }
            waterWaves.layers.mask = -1;
        });
        meshs.forEach((e) => {
            const mesh = e.clone();
            mesh.material = material;
            mesh.position.y += 0.01;
            group.add(mesh);
            mesh.layers.mask = -1;
        });
        group.name = 'waves';
        this.add(group);
        this.waves = group;
        const fn = () => {
            this.wavesAnimateFn.push(fn);
            uniforms.iTime.value += 0.03;
            waterUniforms.iTime.value += 0.05;
        };
        fn();
    }
    addReflect() {
        // 使用cubeCamera实现反射 结论： 反射错误，效果太差。不太适合不规则mesh
        // const meshs = this.scene.getObjectByName('mergedMesh')?.clone() as THREE.Mesh;
        // // 2 ** 10 = 1024
        // const cubeRenderTarget = new THREE.WebGLCubeRenderTarget(2 ** 10);
        // cubeRenderTarget.texture.type = THREE.HalfFloatType;
        // const cubeCamera = new THREE.CubeCamera(1, 1000, cubeRenderTarget);
        // const material = new THREE.MeshStandardMaterial({
        //   envMap: cubeRenderTarget.texture,
        //   roughness: 0.05,
        //   metalness: 1,
        //   transparent: true,
        //   depthWrite: false,
        //   opacity: 0.5,
        // });
        // meshs.material = material;
        // this.reflectMesh = meshs;
        // meshs.position.y += 0.1;
        // meshs.name = 'reflectMesh';
        // cubeCamera.position.copy(meshs.position);
        // this.scene.add(meshs);
        // const scene2 = new THREE.Scene();
        // scene2.background = this.scene.background?.clone()!;
        // scene2.environment = this.scene.environment?.clone()!;
        // scene2.add(meshs!.clone());
        // const fn = () => {
        //   this.reflectAnimateFn.push(fn);
        //   cubeCamera.update(this.renderer, scene2);
        // };
        // fn();
        /* ************************************ */
        // 使用镜子实现反射
        // const meshs = this.scene.getObjectByName('mergedMesh')?.clone() as THREE.Mesh;
        let meshs = null;
        this.scene.traverse((item) => {
            const e = item;
            if (/dx-mesh/.test(e.name.toLowerCase())) {
                meshs = e;
            }
        });
        if (!meshs)
            return;
        const box = new THREE.Box3().setFromObject(meshs);
        const boxSize = box.getSize(new THREE.Vector3());
        const mesh = new Reflector(new THREE.PlaneGeometry(this.skySize, this.skySize), {
            clipBias: 0.003,
            textureWidth: window.innerWidth * window.devicePixelRatio,
            textureHeight: window.innerHeight * window.devicePixelRatio,
            color: 0xffffff,
            opacity: 0.1,
            time: 0,
            lod: 5.0,
            waterNormals: null,
        });
        mesh.position.y = meshs.position.y + 0.1;
        this.reflectMesh = mesh;
        mesh.name = 'reflectMesh';
        mesh.rotateX(-Math.PI / 2);
        this.add(mesh);
        const fn = () => {
            this.reflectAnimateFn.push(fn);
            // mesh.material.uniforms['time'].value += 1.0 / 60.0;
        };
        fn();
    }
    setWeather(weather, config) {
        if (config?.update) {
            // 删除反射
            this.reflectMesh?.geometry.dispose();
            this.reflectMesh?.material.dispose();
            this.reflectMesh && this.remove(this.reflectMesh);
            this.reflectMesh = undefined;
            // 删除涟漪
            this.waves?.children.forEach((e) => {
                const item = e;
                item.geometry.dispose();
                item.material.dispose();
            });
            this.waves && this.remove(this.waves);
            this.waves = undefined;
        }
        const skyUniforms = this.sky.material.uniforms;
        const rain = this.getObjectByName('rain');
        const sky = this.getObjectByName('sky');
        const cloud = this.getObjectByName('cloud');
        const sunnyCloud = this.getObjectByName('sunnyCloud');
        const snow = this.getObjectByName('snow');
        const waves = this.getObjectByName('waves');
        const reflectMesh = this.getObjectByName('reflectMesh');
        waves && this.remove(waves);
        reflectMesh && this.remove(reflectMesh);
        sky && this.remove(sky);
        snow && this.remove(snow);
        cloud && this.remove(cloud);
        sunnyCloud && this.remove(sunnyCloud);
        rain && this.remove(rain);
        this.scene.fog = null;
        this.light.color.set(this.lightColor);
        this.active = weather;
        this.renderer.autoClearColor = false;
        if (this.isSunset) {
            this.skyColorOpacity = 0.1;
        }
        else {
            this.skyColorOpacity = 0.4;
        }
        skyUniforms['opacity'].value = this.skyColorOpacity;
        const angle = (this.angle * Math.PI) / 180;
        switch (weather) {
            case 'sunny':
                // const rain = this.scene.children.find((e) => e.name === 'rain');
                // 移除除晴天以外所有天气效果，并添加sky
                this.renderer.toneMappingExposure = this.exposure;
                // this.light.color.set(new THREE.Color(0xffff99));
                // if (this.angle >= 180 || this.angle <= 0) {
                //   this.light.color.set(new THREE.Color(0xffffff));
                // }
                if (this.sky) {
                    this.add(this.sky);
                    this.light && (this.light.castShadow = true);
                }
                else {
                    this.addSky();
                }
                // 晴天添加少量云
                if (this.sunnyCloud) {
                    this.add(this.sunnyCloud);
                }
                else {
                    let url = '/img/weather/p-cloud2.png';
                    if (Array.isArray(config?.url)) {
                        url = config.url[0];
                    }
                    this.addCloud(url, config?.count || 30, config?.speed, true);
                }
                break;
            case 'rainy':
                this.renderer.toneMappingExposure = this.exposure * 0.8;
                this.renderer.autoClearColor = true;
                this.light && (this.light.castShadow = false);
                if (this.waves) {
                    this.add(this.waves);
                }
                else {
                    this.addWaves();
                }
                if (this.reflectMesh) {
                    this.add(this.reflectMesh);
                }
                else {
                    this.addReflect();
                }
                if (this.rain) {
                    this.add(this.rain);
                }
                else {
                    this.addRain(config || {});
                }
                break;
            case 'cloudy':
                this.add(this.sky);
                // this.light.color.set(new THREE.Color(0xffffcc));
                this.skyColorOpacity = 0.6;
                skyUniforms['opacity'].value = this.skyColorOpacity;
                // if (this.angle >= 180 || this.angle <= 0) {
                //   this.light.color.set(new THREE.Color(0xffffff));
                // }
                this.light && (this.light.castShadow = true);
                this.renderer.toneMappingExposure = this.exposure * 0.85;
                if (this.cloud) {
                    this.add(this.cloud);
                }
                else {
                    let url = '/img/weather/p-cloud2.png';
                    if (Array.isArray(config?.url)) {
                        url = config.url[0];
                    }
                    this.addCloud(url, config?.count || 300, config?.speed);
                }
                break;
            case 'snowy':
                this.light && (this.light.castShadow = false);
                const { url = this.snowTexture, count = 50000, speed = 2, distance = 1000, height = 2500 } = config || {};
                const length = Array.isArray(url) ? url.length : 1;
                this.scene.background = null;
                this.renderer.autoClearColor = true;
                if (this.snow.children.length) {
                    this.add(this.snow);
                }
                else {
                    this.addSnow(url, Math.ceil(count / length), speed, distance, height);
                }
                break;
            default:
                this.setWeather('sunny', config);
                break;
        }
        this.updateSky(this.angle);
    }
    setScenceBackground(color) {
        this.scene.background instanceof THREE.Texture && this.scene.background.dispose();
        if (this.active === 'snowy') {
            this.scene.fog = new THREE.Fog(color, 0.15, 4000);
        }
        else if (this.active === 'rainy') {
            this.scene.fog = new THREE.Fog(color, 0.15, 10000);
        }
        this.scene.fog && this.renderer.setClearColor(this.scene.fog.color);
    }
    getRgb(angle) {
        const rgb = Math.abs(255 * Math.sin((angle * Math.PI) / 180));
        return `rgb(${rgb.toFixed(0)},${rgb.toFixed(0)},${rgb.toFixed(0)})`;
    }
    dispose() {
        window.cancelAnimationFrame(this.animateId);
        this.traverse(function (obj) {
            if (obj instanceof THREE.Mesh) {
                obj.geometry.dispose();
                obj.material.dispose();
            }
            else {
                if (obj.parent) {
                    obj?.parent.remove(obj);
                }
                obj.clear();
            }
        });
        this.rain?.dispose();
        this.snow?.children.forEach((e) => {
            const item = e;
            item.geometry.dispose();
            item.material.dispose();
        });
        this.waves?.children.forEach((e) => {
            const item = e;
            item.geometry.dispose();
            item.material.dispose();
        });
        this.reflectMesh?.geometry.dispose();
        this.reflectMesh?.material.dispose();
        this.light?.dispose();
        this.ambientLight?.dispose();
        this.parent?.remove(this);
        this.clear();
    }
}
class RainWaves extends ShaderMaterial {
    vertexShader = `
    varying vec2 vUv;
    varying vec3 vNormal;
    void main(){
      vUv = uv;
      vNormal = normal;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `;
    fragmentShader = `
    varying vec2 vUv;
    varying vec3 vNormal;
    uniform vec3      iResolution;           // 视口分辨率（像素）
    uniform float     iTime;  
    uniform float     normalY;  
    uniform float     MAX_RADIUS;  
    uniform float     resolution;  
    uniform sampler2D iChannel0;
    
    // #define MAX_RADIUS 2

// Set to 1 to hash twice. Slower, but less patterns.
#define DOUBLE_HASH 0

#define HASHSCALE1 .1031
#define HASHSCALE3 vec3(.1031, .1030, .0973)

float hash12(vec2 p)
{
    vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);
    p3 += dot(p3, p3.yzx + 19.19);
    return fract((p3.x + p3.y) * p3.z);
}

vec2 hash22(vec2 p)
{
    vec3 p3 = fract(vec3(p.xyx) * HASHSCALE3);
    p3 += dot(p3, p3.yzx+19.19);
    return fract((p3.xx+p3.yz)*p3.zy);

}

void main( )
{
    vec2 uv = vUv.xy / iResolution.y * resolution;
    vec2 p0 = floor(uv);

    vec2 circles = vec2(0.);
    for (float j = -MAX_RADIUS; j <= MAX_RADIUS; ++j)
    {
        for (float i = -MAX_RADIUS; i <= MAX_RADIUS; ++i)
        {
            vec2 pi = p0 + vec2(i, j);
            #if DOUBLE_HASH
            vec2 hsh = hash22(pi);
            #else
            vec2 hsh = pi;
            #endif
            vec2 p = pi + hash22(hsh);

            float t = fract(0.3*iTime + hash12(hsh));
            vec2 v = p - uv;
            float d = length(v) - (MAX_RADIUS + 1.)*t;

            float h = 1e-3;
            float d1 = d - h;
            float d2 = d + h;
            float p1 = sin(31.*d1) * smoothstep(-0.6, -0.3, d1) * smoothstep(0., -0.3, d1);
            float p2 = sin(31.*d2) * smoothstep(-0.6, -0.3, d2) * smoothstep(0., -0.3, d2);
            circles += 0.5 * normalize(v) * ((p2 - p1) / (2. * h) * (1. - t) * (1. - t));
        }
    }
    circles /= float((MAX_RADIUS*2.+1.)*(MAX_RADIUS*2.+1.));

    float intensity = mix(0.01, 0.15, smoothstep(0.1, 0.6, abs(fract(0.05*iTime + 0.5)*2.-1.)));
    vec3 n = vec3(circles, sqrt(1. - dot(circles, circles)));
    vec4 color = texture(iChannel0, uv/resolution - intensity*n.xy).rgba + 5.*pow(clamp(dot(n, normalize(vec3(1., 0.7, 0.5))), 0., 1.), 6.);
    if (vNormal.y >= normalY){
      gl_FragColor =  color;     
    } else {
      gl_FragColor =  vec4(0,0,0,0);
    }
}
  `;
}
class CloudMaterial extends ShaderMaterial {
    vertexShader = `
    varying vec2 vUv;
    varying vec3 vNormal;
    void main(){
      vUv = uv;
      vNormal = normal;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `;
    fragmentShader = `
    varying vec2 vUv;
    varying vec3 vNormal;
    uniform vec3      iResolution;           // 视口分辨率（像素）
    uniform float     iTime;  
    uniform vec4     iMouse;
    uniform sampler2D iChannel0;  

    vec3 R = vec3(2.,4.,2.);              // ellipsoid radius
    vec3 L = normalize(vec3(-.4,0.,1.));  // light source
    #define AMBIENT .4  // ambient luminosity
    
    #define ANIM true
    #define PI 3.1415927
    vec4 FragColor;
    
    bool keyToggle(int ascii) {
      return (texture(iChannel0,vec2((.5+float(ascii))/256.,0.75)).x > 0.);
    }
    
    // --- noise functions from https://www.shadertoy.com/view/XslGRr
    // Created by inigo quilez - iq/2013
    // License Creative Commons Attribution-NonCommercial-ShareAlike 3.0 Unported License.
    
    mat3 m = mat3( 0.00,  0.80,  0.60,
                  -0.80,  0.36, -0.48,
                  -0.60, -0.48,  0.64 );
    
    float hash( float n )    // in [0,1]
    {
        return fract(sin(n)*43758.5453);
    }
    
    float noise( in vec3 x ) // in [0,1]
    {
        vec3 p = floor(x);
        vec3 f = fract(x);
    
        f = f*f*(3.0-2.0*f);
    
        float n = p.x + p.y*57.0 + 113.0*p.z;
    
        float res = mix(mix(mix( hash(n+  0.0), hash(n+  1.0),f.x),
                            mix( hash(n+ 57.0), hash(n+ 58.0),f.x),f.y),
                        mix(mix( hash(n+113.0), hash(n+114.0),f.x),
                            mix( hash(n+170.0), hash(n+171.0),f.x),f.y),f.z);
        return res;
    }
    
    float fbm( vec3 p )    // in [0,1]
    {
      if (ANIM) p += iTime;
        float f;
        f  = 0.5000*noise( p ); p = m*p*2.02;
        f += 0.2500*noise( p ); p = m*p*2.03;
        f += 0.1250*noise( p ); p = m*p*2.01;
        f += 0.0625*noise( p );
        return f;
    }
    // --- End of Created by inigo quilez
    
    float snoise( in vec3 x ) // in [-1,1]
    { return 2.*noise(x)-1.; }
    
    float sfbm( vec3 p )      // in [-1,1]
    {
      if (ANIM) p += iTime;
        float f;
        f  = 0.5000*snoise( p ); p = m*p*2.02;
        f += 0.2500*snoise( p ); p = m*p*2.03;
        f += 0.1250*snoise( p ); p = m*p*2.01;
        f += 0.0625*snoise( p );
        return f;
    }
    
    
    
    // --- view matrix when looking T from O with [-1,1]x[-1,1] screen at dist d
    
    
    mat3 lookat(vec3 O, vec3 T, float d) {
      mat3 M;
      vec3 OT = normalize(T-O);
      M[0] = OT;
      M[2] = normalize(vec3(0.,0.,1.)-OT.z*OT)/d;
      M[1] = cross(M[2],OT);
      return M;
    }
    
    // --- ray -  ellipsoid intersection
    // if true, return P,N and thickness l
    
    bool intersect_ellipsoid(vec3 O, vec3 D, out vec3 P, out vec3 N, out float l) {
      vec3 OR = O/R, DR = D/R; // to space where ellipsoid is a sphere 
        // P=O+tD & |P|=1 -> solve t in O^2 +2(O.D)t + D^2.t^2 = 1
      float OD = dot(OR,DR), OO=dot(OR,OR), DD=dot(DR,DR);
      float d = OD*OD - (OO-1.)*DD;
      
      if (!((d >=0.)&&(OD<0.)&&(OO>1.))) return false;
      // ray intersects the ellipsoid (and not in our back)
      // note that t>0 <=> -OD>0 &  OD^2 > OD^ -(OO-1.)*DD -> |O|>1
        
      float t = (-OD-sqrt(d))/DD;
      // return intersection point, normal and thickness
      P = O+t*D;
      N=normalize(P/(R*R));
      l = 2.*sqrt(d)/DD;
    
      return true;
    }
    
    // --- Gardner textured ellipsoids (sort of)
    
    // 's' index corresponds to Garner faked silhouette
    // 'i' index corresponds to interior term faked by mid-surface
    
    float ks,ps, ki,pi;  // smoothness/thichness parameters
    
    float l;
    void draw_obj(vec3 O, mat3 M, vec2 pos, int mode) {
      vec3 D = normalize(M*vec3(1.,pos)); // ray
      
      vec3 P,N; 
      if (! intersect_ellipsoid(O,D, P,N,l)) return;
      
      vec3 Pm = P+.5*l*D,                // .5: deepest point inside cloud. 
         Nm = normalize(Pm/(R*R)),     // it's normal
           Nn = normalize(P/R);
      float nl = clamp( dot(N,L),0.,1.), // ratio of light-facing (for lighting)
          nd = clamp(-dot(Nn,D),0.,1.); // ratio of camera-facing (for silhouette)
                // try 1.
    
      float ns = fbm(P), ni = fbm(Pm+10.);
      float A, l0 = 3.;
      //l += l*(l/l0-1.)/(1.+l*l/(l0*l0));     // optical depth modified at silhouette
      l = clamp(l-6.*ni,0.,1e10);
      float As = pow(ks*nd, ps), // silhouette
          Ai = 1.-pow(.7,pi*l);              // interior
    
    
      As =clamp(As-ns,0.,1.)*2.; // As = 2.*pow(As ,.6);
      if (mode==2) 
        A = 1.- (1.-As)*(1.-Ai);  // mul Ti and Ts
      else
        A = (mode==0) ? Ai : As; 
      A = clamp(A,0.,1.); 
      nl = .8*( nl + ((mode==0) ? fbm(Pm-10.) : fbm(P+10.) ));
    
      #if 0 // noise bump
      N = normalize(N -.1*(dFdx(A)*M[1]+dFdy(A)*M[2])*iResolution.y); 
      nl = clamp( dot(N,L),0.,1.);
    #endif
      
      vec4 col = vec4(mix(nl,1.,AMBIENT));
      FragColor = mix(FragColor,col,A);
    }
    
    // === main =============================================
    
    void main( ) {
      float t = iTime;
        vec2 uv = 2.*(vUv.xy / iResolution.y-vec2(.85,.5));
      vec2 mouse = 2.*(iMouse.xy / iResolution.xy - vec2(.85,.5));
      float z = .2;
      ks = 1.+mouse.x, ps = mouse.y*8., ki, pi;
      ks = 1.; ps = 3.;   ki = .9; pi = 3.;
      
      if (iMouse.z>0.) {
        t = -PI/2.*mouse.x;
        z = -PI/2.*mouse.y;
      }
      vec3 O = vec3(-15.*cos(t)*cos(z),15.*sin(t)*cos(z),15.*sin(z)); // camera
      float compas = t-.2*uv.x; vec2 dir = vec2(cos(compas),sin(compas));
      FragColor = (keyToggle(64+19)) 
        ? vec4(0.) 
        : clamp(vec4(.6,.7+.3*dir,1.)*(uv.y+1.6)/1.8,0.,0.); // sky
    
      mat3 M = lookat(O,vec3(0.),5.); 
      vec2 dx = vec2(1.,0.);
      
      if (!keyToggle(32))
        draw_obj(O,M, uv, 2);
      else {
        draw_obj(O,M, 1.5*(uv+dx), 0);
        draw_obj(O,M, 1.5*(uv-dx), 1);
      }
        
      gl_FragColor = FragColor; 
    }
    
  `;
}
export default Weather;
